var _defs, _path, _path2, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bf97f450-0d91-4db3-8ea1-010780a2af52",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe22bed8-8e36-415d-8032-3026ad9e8503",
    x1: 8.56,
    y1: 17.59,
    x2: 8.56,
    y2: 0.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1988d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#218ddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#379ce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#54aef0"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-general-5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b3492ff9-55dd-4864-be78-9e79f3547897",
    d: "M13.77,15.81A8.5,8.5,0,0,1,3.35,2.37l.09-.06a8.5,8.5,0,0,1,10.33,13.5",
    fill: "url(#fe22bed8-8e36-415d-8032-3026ad9e8503)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56,6.17a1.24,1.24,0,0,1-.89-.33,1,1,0,0,1-.34-.79,1,1,0,0,1,.34-.79A1.31,1.31,0,0,1,8.56,4a1.28,1.28,0,0,1,.89.3,1,1,0,0,1,.35.79,1,1,0,0,1-.35.8A1.24,1.24,0,0,1,8.56,6.17Zm.64,8.05H7.89a.42.42,0,0,1-.42-.42V7.69a.42.42,0,0,1,.42-.42H9.2a.42.42,0,0,1,.42.42V13.8A.42.42,0,0,1,9.2,14.22Z",
    fill: "#fff"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", {
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  }, /*#__PURE__*/React.createElement("rdfLi", null, "public:true"), /*#__PURE__*/React.createElement("rdfLi", null, "sdk:MsPortalFx.Base.Images.Polychromatic.Info()"), /*#__PURE__*/React.createElement("rdfLi", null, "category: General")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/Information.4247aa4531e23727d7e50f1d132f4040.svg";
export { ForwardRef as ReactComponent };